export function findScrollContainer(
  element: HTMLElement | undefined,
  offset = 0
): HTMLElement {
  if (!element) {
    return document.documentElement
  }
  const styles = getComputedStyle(element)
  offset += parseInt(styles.marginTop) + parseInt(styles.marginBottom)

  const container = element?.parentElement
  if (!container) {
    return document.documentElement
  }

  const diff = container.scrollHeight - container.clientHeight + offset
  const isScrollable = container.clientHeight > 0 && diff > 0

  const style = getComputedStyle(container)
  const hasOverflowY = ['scroll', 'auto'].includes(style.overflowY)

  if (isScrollable || hasOverflowY) {
    return container
  }

  return findScrollContainer(container, offset)
}
